<template>
  <div class="circle-list">
    <div
      v-for="(item, index) in data"
      :key="index"
      @click.stop="jumpDynamicDetail(item, index)"
    >
      <div class="circle-item">
        <div class="circle-top">
          <img
            class="avatar"
            :src="item.head_img || defaultAvatar[0]"
            @click.stop="jumpUserinfo(item)"
          />
          <div class="user-info">
            <div>
              <span class="true-name">{{ item.truename || '' }}</span>
              <span
                class="gender iconfont"
                :class="[formatGenderIcon(item.gender)]"
              ></span>
            </div>
            <div class="nickname" v-if="item.nickname">
              <span>({{ item.nickname }})</span>
            </div>
          </div>
        </div>
        <div class="circle-center">
          <div class="content" v-if="item.meal_introduction">
            {{ item.meal_introduction }}
          </div>
          <div class="image-list">
            <img
              class="image-item"
              :class="{
                'image-item-50': item.meal_img.length > 1,
                'image-item-100': item.meal_img.length <= 1
              }"
              v-for="(imgitem, index1) in item.meal_img"
              :key="index1"
              :src="
                formatImageUrl(
                  imgitem + '?x-oss-process=image/resize,w_300/quality,Q_50'
                )
              "
              v-show="imgitem && index1 < 4"
            />
          </div>
        </div>
        <div class="tag-list">
          <div
            class="tag-item"
            v-for="(tagitem, tagindex) in item.label"
            :key="tagindex"
          >
            {{ tagitem }}
          </div>
        </div>
        <div class="new-comment" v-if="item.comment && item.comment.comment">
          <div class="new-comment-item">
            <div class="comment-info">
              <img class="comment-avatar" :src="item.comment.head_img" />
              <div class="comment-name">{{ item.comment.nickname }}</div>
            </div>
            <div class="comment">{{ item.comment.comment }}</div>
          </div>
        </div>
        <div class="circle-bottom">
          <div class="time">{{ item.created_at }}</div>
        </div>
        <div class="reviews" v-if="type == 1">
          <div class="iconfont icon-yingyangshigongju"></div>
          <div>点评</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScoreContent from './score-content.vue'
import FlagComponent from './flag-component.vue'
export default {
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {
    ScoreContent,
    FlagComponent
  },
  filters: {
    formatDynamicNumber(num) {
      if (num === '') {
        return num
      }
      var res = ''
      num = isNaN(parseInt(num)) ? '-' : parseInt(num)
      if (num === '-') {
        return '-'
      }
      if (num >= 100000) {
        res = '10w+'
      } else if (num >= 10000) {
        res = (num / 10000).toFixed(1) + 'w'
      } else if (num >= 1000) {
        res = (num / 1000).toFixed(1) + 'k'
      } else {
        res = num
      }
      return res
    }
  },
  data() {
    return {
      defaultAvatar: [
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png',
        'https://cdnvue.gymcity.com.cn/uploads/1ce985d5712871e05b0d65e638924a29.png',
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png'
      ],
      isPhone: '',
      tcTextArr: ['入营', '日常', '结营'],
      clockType: ['', '', '体测', '饮食', '运动', '习惯'],
      dietArr: ['早餐', '午餐', '晚餐', '加餐'],
      tagType: {
        1: 'tag-type-advantage',
        2: 'tag-type-disadvantage'
      }
    }
  },
  created() {},
  methods: {
    //点赞
    bindLike(index) {
      this.$emit('like', index, this.type)
    },
    formatImageUrl(imageUrl) {
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    formatGenderIcon(gender) {
      var res = ''
      if (gender == 1) {
        res = 'icon-nan-5'
      } else if (gender == 2) {
        res = 'icon-nv-3'
      } else {
        res = 'icon-wenhao4'
      }
      return res
    },
    //进入动态详情
    jumpDynamicDetail(item, index) {
      this.$emit('into', item, index)
    },
    //点赞
    likeThis(e) {
      let index = e.currentTarget.dataset.index
      this.triggerEvent(
        'like',
        {
          index,
          type: this.data.type
        },
        {}
      )
    },
    //跳转到用户信息
    jumpUserinfo(item) {
      this.$emit('userinfo', item)
    },
    //关注用户
    followUser(e) {
      let id = e.currentTarget.dataset.item.unify_id
      let index = e.currentTarget.dataset.index
      this.triggerEvent('follow', { id, index }, {})
    }
  }
}
</script>
<style lang="scss" scoped>
.circle-list {
  color: #000;
}

.circle-item {
  background-color: #fff;
  padding: 15px 16px;
  margin-bottom: 10px;
}

.circle-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.true-name {
  margin-right: 9px;
}

.icon-nv-3 {
  color: rgb(255, 110, 110);
}

.icon-nan-5 {
  color: rgb(52, 153, 219);
}

.icon-wenhao4 {
  color: rgba(0, 0, 0, 0.5);
}

.circle-top .nickname {
  color: rgba(0, 0, 0, 0.5);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 9px;
}

.user-info {
  font-size: 12px;
  flex: 1;
  font-weight: 600;
}

.coach-flag {
  display: inline-block;
  padding: 0px 12px;
  height: 14px;
  background-image: linear-gradient(180deg, #ff4e4e 0%, #ff2c55 100%);
  border-radius: 3px;
  font-size: 9px;
  color: #fff;
}

.not-attention {
  text-align: center;
  color: #fff;
  width: 60px;
  font-size: 13px;
  line-height: 24px;
  height: 24px;
  background-color: #f04646;
  border-radius: 12px;
}

.attention {
  text-align: center;
  color: #aaa;
  width: 60px;
  font-size: 13px;
  line-height: 24px;
  height: 24px;
  border-radius: 12px;
}

.content {
  font-size: 14px;
  margin-bottom: 10px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
}

.image-list {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.diet-flag {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 7;
}

.image-item {
  margin-bottom: 8px;
  width: 168px;
  height: 168px;
  border-radius: 5px;
  object-fit: cover;
}

.image-item-50 {
  width: 168px;
}

.image-item-100 {
  width: 336px;
  height: 336px;
}

.tag-list {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.tag-item {
  color: rgb(31, 55, 90);
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  padding: 0px 10px;
  background-color: #97ccf0;
  border-radius: 12px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.circle-bottom {
  color: #aaa;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 18px;
}

.circle-bottom .icon-home_tab_message {
  color: #ccc;
  font-size: 15px;
  margin-right: 5px;
}

.circle-bottom .icon-like {
  color: #e5004a;
}

.comment-btn,
.like-btn {
  display: flex;
  align-items: center;
}

.comment-btn {
  margin-right: 20px;
}

.like-btn {
  margin-right: 20px;
}

.time {
  flex: 1;
  text-align: right;
}

.new-comment {
  background-color: #f7f7f7;
  border-radius: 5px;
  padding: 11px 16px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.comment-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.comment-avatar {
  width: 16px;
  height: 16px;
  background-color: #b4b4b4;
  border-radius: 4px;
  margin-right: 8px;
}

.comment-name {
  flex: 1;
  width: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  font-size: 12px;
  color: #000000;
}

.new-comment .comment {
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.6);
}

.icon-xinxing {
  margin-right: 8px;
  color: rgb(197, 197, 197);
  font-size: 15px;
}

.like-active {
  color: rgb(240, 70, 70);
}

.reviews {
  color: #fff;
  font-size: 15px;
  width: 336px;
  height: 36px;
  background-color: #3b4761;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reviews .iconfont {
  margin-right: 10px;
}

.reviews-content .coach-info {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.reviews-content .avatar {
  width: 16px;
  height: 16px;
  background-color: #b4b4b4;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 5px;
}

.reviews-content .nickname {
  font-weight: 600;
  height: 17px;
  font-size: 12px;
  color: #000;
}

.reviews-content .say {
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
  white-space: pre-wrap;
}

.reviews-content .tag-list {
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
}

.tag-item {
  padding: 3px 9px;
  font-size: 12px;
  background-color: #f9f9f9;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.tag-list .tag-type-advantage {
  background-color: rgba(53, 199, 99, 0.1);
  color: #63a477;
}

.tag-list .tag-type-disadvantage {
  background-color: rgba(240, 70, 70, 0.1);
  color: #dd8585;
}
.data-diff {
  text-indent: 10px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 6px;
}
.data-info {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 6px;

  .data-item {
    width: 111px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .d-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      margin-right: 8px;
      height: 17px;
      line-height: 17px;
    }

    .d-num {
      font-size: 14px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      height: 17px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 2px;
    }

    .d-unit {
      font-size: 10px;
      font-family: DINCondensed-Bold, DINCondensed;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 4px;
      height: 17px;
      line-height: 22px;
    }

    .d-div {
      width: 24px;
      height: 12px;
      background: #35c763;
      box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      .iconfont {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4px;
        height: 8px;
        line-height: 8px;
        font-size: 8px;
      }

      .rotate {
        transform: rotate(180deg);
        transform-origin: center center;
      }

      .change-num {
        margin-left: 4px;
        height: 12px;
        line-height: 15px;
        font-size: 10px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
      }
    }

    .d-red {
      background-color: #f04646;
    }

    .d-green {
      background-color: #35c763;
    }
  }

  .data-item::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    width: 1px;
    height: 6px;
    background-color: #e4e4e4;
  }

  .data-item:last-child::after {
    display: none;
  }
}
</style>
